module.exports = __webpack_public_path__ + "static/media/IconTemplates_-25.2b9673d6.svg";